import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, RouterModule } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { AuthService } from "../auth.service";
import { Subscription } from "rxjs";
import { TranslateModule } from "@ngx-translate/core";
import { StorageService } from "../../shared/services/storage.service";

@Component({
  selector: "app-login",
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule, TranslateModule],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
})
export class LoginComponent {
  public show: boolean = false;
  public loginForm: FormGroup;
  protected subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private authService: AuthService,
    private storageService: StorageService,
  ) {
    const userData = this.storageService.getFromLocalOrSessionStorage("user");
    if (userData != null) {
      router.navigate(["/pages/lista-utenti"]);
    }

    this.loginForm = this.fb.group({
      /*email: ["Test@gmail.com", [Validators.required, Validators.email]],
      password: ["test123", Validators.required],*/
      email: ["", [Validators.required, Validators.email]], //super@admin.com
      password: ["", Validators.required], // secret
      rememberMe: [true],
    });
  }

  showPassword() {
    this.show = !this.show;
  }

  login() {
    if (this.loginForm.valid) {
      const { email, password, rememberMe } = this.loginForm.value;
      const sub = this.authService.login(email, password).subscribe({
        next: (res: any) => {
          let user = {
            email: res.data.email,
            token: res.data.token,
            is_admin: res.data.is_admin,
            role: res.data.role,
          };
          if (rememberMe) {
            localStorage.setItem("user", JSON.stringify(user));
          } else {
            sessionStorage.setItem("user", JSON.stringify(user));
          }
          const userRole = this.authService.getRole();
          if (userRole === true) {
            this.router.navigate(["/anagrafiche/lista-utenti"]);
          } else {
            //this.router.navigate(["/login"]);
            this.router.navigateByUrl("/pages/dashboard");
          }
        },
        error: (error) => {
          console.error("Errore di login:", error);
        },
      });
      this.subscriptions.push(sub);
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
}
